import { render, staticRenderFns } from "./creditLimit.vue?vue&type=template&id=b52ce1c6&scoped=true"
import script from "./creditLimit.vue?vue&type=script&lang=js"
export * from "./creditLimit.vue?vue&type=script&lang=js"
import style0 from "./creditLimit.vue?vue&type=style&index=0&id=b52ce1c6&prod&lang=stylus&scoped=true"
import style1 from "./creditLimit.vue?vue&type=style&index=1&id=b52ce1c6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52ce1c6",
  null
  
)

export default component.exports